import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

const apiUrl = import.meta.env.VITE_API_URL

interface InviteData {
  organization_name: string
  persona_name: string
  token: string
}

export function PendingInviteChecker() {
  const { getAccessTokenSilently } = useAuth0()
  const [modalInviteStatus, setModalInviteStatus] = React.useState(false)
  const [hasDismissed] = React.useState(false)
  const [inviteDetails, setInviteDetails] = React.useState<InviteData | null>(
    null
  )

  const { data } = useQuery({
    queryKey: ['pendingInvite'],
    queryFn: async (): Promise<InviteData | null> => {
      const accessToken = await getAccessTokenSilently()
      const response = await fetch(`${apiUrl}/user/invite/find/pending`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })

      if (response.status === 404) return null
      if (!response.ok) return null //throw new Error('Failed to fetch invites')
      return response.json()
    },
    retry: false,
    staleTime: Infinity,
  })

  React.useEffect(() => {
    if (data && !hasDismissed) {
      // Check if current page is not the invite page
      const isInvitePage = window.location.pathname === '/invite'
      if (!isInvitePage) {
        setInviteDetails(data)
        setModalInviteStatus(true)
      }
    }
  }, [data, hasDismissed])

  // Don't render anything if on invite page
  if (!inviteDetails || window.location.pathname === '/invite') return null

  const inviteUrl = `${window.location.origin}/invite?invite=${encodeURIComponent(inviteDetails.token)}`

  return (
    <Dialog open={modalInviteStatus} onOpenChange={setModalInviteStatus}>
      <DialogContent className='rounded-lg sm:max-w-md'>
        <DialogHeader>
          <DialogTitle className='text-lg font-bold text-gray-900'>
            Você foi convidado! 🎉
          </DialogTitle>
        </DialogHeader>

        <div className='mt-4'>
          <p className='text-gray-600'>
            Você recebeu o convite da{' '}
            <span className='font-semibold text-purple-600'>
              {inviteDetails.organization_name}
            </span>{' '}
            e precisa aceitá-lo para continuar.
          </p>
        </div>

        <div className='mt-6 flex gap-3'>
          <a
            href={inviteUrl}
            className='flex-1 rounded-lg bg-purple-600 px-4 py-2 text-center font-medium text-white hover:bg-purple-700'
          >
            Aceitar Convite
          </a>
          {/*<button
            onClick={() => {
              setModalInviteStatus(false)
              setHasDismissed(true)
            }}
            className='rounded-lg border px-4 py-2 font-medium text-gray-700 hover:bg-gray-50'
          >
            Depois
          </button>*/}
        </div>
      </DialogContent>
    </Dialog>
  )
}
